import React, { useState, useEffect } from 'react';
import Sidebar from '../Shared/Sidebar';
import Icon from '../Shared/Icons';
import { useAuth } from '../../context/AuthContext';
import { PROGRAMS } from '../../config/programs';
import {
  fetchAnnouncements, saveAnnouncement, deleteAnnouncement, resolveAuthorName,
} from '../../utils/programData';
import { S, T } from './ui';

const TYPES = [
  { key: 'tangazo', label: 'Tangazo', color: '#1565C0' },
  { key: 'event', label: 'Tukio / Event', color: '#E07A2E' },
  { key: 'activity', label: 'Activity', color: '#00695C' },
];

const EMPTY = {
  title: '', body: '', type: 'tangazo', date: '', time: '',
  location: '', programId: 'all', pinned: false,
};

export default function Announcements() {
  const { currentUser, userRole } = useAuth();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [editingId, setEditingId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => { load(); }, []);

  async function load() {
    try { setItems(await fetchAnnouncements()); }
    catch (e) { console.error(e); }
  }

  function change(k, v) { setForm(f => ({ ...f, [k]: v })); }

  async function submit() {
    if (!form.title.trim()) { setErr('Andika kichwa cha tangazo.'); return; }
    setSaving(true); setErr('');
    try {
      const name = await resolveAuthorName(currentUser);
      await saveAnnouncement({
        ...form,
        createdBy: currentUser.uid,
        createdByName: name,
      }, editingId);
      setMsg(editingId ? 'Tangazo limebadilishwa.' : 'Tangazo limewekwa.');
      setForm(EMPTY); setEditingId(null); setShowForm(false);
      load();
      setTimeout(() => setMsg(''), 3000);
    } catch (e) {
      console.error(e);
      setErr('Imeshindikana kuhifadhi. Jaribu tena.');
    }
    setSaving(false);
  }

  async function remove(id) {
    if (!window.confirm('Una uhakika unataka kufuta tangazo hili?')) return;
    try { await deleteAnnouncement(id); load(); }
    catch (e) { console.error(e); setErr('Imeshindikana kufuta.'); }
  }

  function edit(a) {
    setForm({
      title: a.title || '', body: a.body || '', type: a.type || 'tangazo',
      date: a.date || '', time: a.time || '', location: a.location || '',
      programId: a.programId || 'all', pinned: !!a.pinned,
    });
    setEditingId(a.id);
    setShowForm(true);
    window.scrollTo(0, 0);
  }

  const today = new Date().toISOString().split('T')[0];
  const upcoming = items.filter(a => !a.date || a.date >= today);
  const past = items.filter(a => a.date && a.date < today).reverse();

  return (
    <div style={S.layout}>
      <Sidebar />
      <div style={S.main}>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '18px', gap: '12px' }}>
          <div>
            <h1 style={S.h1}>Matangazo & Ratiba</h1>
            <p style={{ ...S.sub, marginTop: '6px' }}>
              Kila kitu kinachokuja — matukio, activity na taarifa muhimu kwa staff wote.
            </p>
          </div>
          <button style={S.btn} onClick={() => { setShowForm(!showForm); setEditingId(null); setForm(EMPTY); }}>
            {showForm ? 'Funga' : '+ Weka'}
          </button>
        </div>

        {msg && <div style={S.ok}>{msg}</div>}
        {err && <div style={S.err}>{err}</div>}

        {showForm && (
          <div style={S.card}>
            <h2 style={S.h2}>{editingId ? 'Badilisha tangazo' : 'Tangazo jipya'}</h2>

            <label style={S.label}>Aina</label>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
              {TYPES.map(t => (
                <button
                  key={t.key}
                  onClick={() => change('type', t.key)}
                  style={{
                    padding: '9px 16px', borderRadius: '99px', cursor: 'pointer',
                    border: `1px solid ${form.type === t.key ? t.color : T.line}`,
                    background: form.type === t.key ? t.color : '#fff',
                    color: form.type === t.key ? '#fff' : T.muted,
                    fontSize: '12.5px', fontWeight: 700, fontFamily: 'inherit',
                  }}
                >{t.label}</button>
              ))}
            </div>

            <label style={S.label}>Kichwa *</label>
            <input style={{ ...S.input, marginBottom: '16px' }} value={form.title}
              onChange={e => change('title', e.target.value)}
              placeholder="mf. Mashindano ya chess Shule ya Msingi Kaloleni" />

            <label style={S.label}>Maelezo</label>
            <textarea style={{ ...S.input, minHeight: '90px', marginBottom: '16px', resize: 'vertical' }}
              value={form.body} onChange={e => change('body', e.target.value)}
              placeholder="Nini kinatakiwa kufanyika, nani anahusika, maandalizi gani..." />

            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              <div style={{ flex: '1 1 140px' }}>
                <label style={S.label}>Tarehe</label>
                <input type="date" style={{ ...S.input, marginBottom: '16px' }} value={form.date}
                  onChange={e => change('date', e.target.value)} />
              </div>
              <div style={{ flex: '1 1 120px' }}>
                <label style={S.label}>Muda</label>
                <input type="time" style={{ ...S.input, marginBottom: '16px' }} value={form.time}
                  onChange={e => change('time', e.target.value)} />
              </div>
            </div>

            <label style={S.label}>Mahali</label>
            <input style={{ ...S.input, marginBottom: '16px' }} value={form.location}
              onChange={e => change('location', e.target.value)} placeholder="mf. Usa River YDC" />

            <label style={S.label}>Programu inayohusika</label>
            <select style={{ ...S.input, marginBottom: '16px' }} value={form.programId}
              onChange={e => change('programId', e.target.value)}>
              <option value="all">Programu zote</option>
              {PROGRAMS.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>

            <label style={{ display: 'flex', alignItems: 'center', gap: '9px', cursor: 'pointer', fontSize: '13.5px', color: '#374151', marginBottom: '18px' }}>
              <input type="checkbox" checked={form.pinned} onChange={e => change('pinned', e.target.checked)}
                style={{ width: '17px', height: '17px' }} />
              Bandika juu (muhimu sana)
            </label>

            <button style={{ ...S.btn, opacity: saving ? 0.6 : 1 }} disabled={saving} onClick={submit}>
              {saving ? 'Inahifadhi...' : editingId ? 'Hifadhi mabadiliko' : 'Weka tangazo'}
            </button>
          </div>
        )}

        <h2 style={{ ...S.h2, marginTop: '6px' }}>Yanayokuja ({upcoming.length})</h2>
        {upcoming.length === 0 && <div style={{ ...S.card, ...S.empty }}>Hakuna tangazo lililopangwa.</div>}
        {upcoming.map(a => (
          <Row key={a.id} a={a} onEdit={edit} onDelete={remove} canManage={userRole === 'admin' || a.createdBy === currentUser?.uid} />
        ))}

        {past.length > 0 && (
          <>
            <h2 style={{ ...S.h2, marginTop: '22px' }}>Yaliyopita ({past.length})</h2>
            {past.slice(0, 15).map(a => (
              <Row key={a.id} a={a} onEdit={edit} onDelete={remove} faded
                canManage={userRole === 'admin' || a.createdBy === currentUser?.uid} />
            ))}
          </>
        )}

      </div>
    </div>
  );
}

function Row({ a, onEdit, onDelete, canManage, faded }) {
  const meta = TYPES.find(t => t.key === a.type) || TYPES[0];
  return (
    <div style={{ ...S.card, opacity: faded ? 0.6 : 1, borderLeft: `4px solid ${meta.color}` }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '7px', marginBottom: '5px', flexWrap: 'wrap' }}>
            <span style={{ ...S.pill, color: meta.color, background: `${meta.color}15` }}>{meta.label}</span>
            {a.pinned && <span style={{ ...S.pill, color: '#E07A2E', background: '#E07A2E15' }}>★ Muhimu</span>}
          </div>
          <div style={{ fontSize: '15px', fontWeight: 700, color: T.ink, lineHeight: 1.4 }}>{a.title}</div>
          {a.body && <div style={{ fontSize: '13px', color: T.muted, marginTop: '6px', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{a.body}</div>}
          <div style={{ fontSize: '11.5px', color: T.muted, marginTop: '9px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            {a.date && <span><Icon name="calendar" size={11} /> {a.date}{a.time ? ` · ${a.time}` : ''}</span>}
            {a.location && <span>📍 {a.location}</span>}
            {a.createdByName && <span>— {a.createdByName}</span>}
          </div>
        </div>
        {canManage && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <button onClick={() => onEdit(a)} style={{ ...S.btnGhost, padding: '6px 12px', fontSize: '11.5px' }}>Badilisha</button>
            <button onClick={() => onDelete(a.id)} style={{ ...S.btnGhost, padding: '6px 12px', fontSize: '11.5px', color: '#DC2626' }}>Futa</button>
          </div>
        )}
      </div>
    </div>
  );
}
